import objectPath from "object-path";

export default {
    layoutConfig: state => (path, defaultValue) => {
        return objectPath.get(state.config, path, defaultValue);
    },
    getClasses: state => position => {
        if (typeof position !== "undefined") {
            return state.classes[position];
        }
        return state.classes;
    }
}